import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import routeKey from "../routeKey";

/** Resets scroll position on route change — React Router does not do this. */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  /* Keyed on the page, not the raw path: opening a product drawer changes
     the URL but should leave the catalogue scrolled where it was. */
  const page = routeKey(pathname);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [page]);

  return null;
};

export default ScrollToTop;
